<template>
  <div>
    <el-dialog
      destroy-on-close
      :visible.sync="dialogVisible"
      :title="`${mainForm.product_id ? '编辑' : '新增'}项目`"
      width="500px"
      class="activity-type"
      @close="handleCloseDialog"
    >
      <el-form
        size="medium"
        :model="mainForm"
        :rules="rules"
        ref="mainForm"
        label-width="80px"
      >
        <el-form-item label="名称:" prop="title">
          <el-input
            placeholder="请输入名称"
            maxlength="99"
            v-model="mainForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类:" prop="category_id">
          <el-radio-group v-model="mainForm.category_id">
            <el-radio-button :label="1">物品</el-radio-button>
            <el-radio-button :label="2">服务</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="mwow-button-filled" @click="handleCloseDialog"
          >取消</el-button
        >
        <el-button
          class="mwow-button-filled success"
          type="success"
          @click="handleSubmit"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getProductListApi,
  createProductApi,
  editProductApi,
  deleteProductApi,
} from "@/api/product";
export default {
  props: ["visible", "origin-data"],
  data() {
    return {
      dialogVisible: false,
      mainForm: {
        title: "",
        category_id: 1,
      },
      rules: {
        title: [{ required: true, message: "请填写名称", trigger: "blur" }],
        category_id: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    visible(n) {
      if (n) {
        this.dialogVisible = true;
        this.mainForm = {
          product_id: this.originData.product_id,
          title: this.originData.title,
          category_id: this.originData.category_id,
        };
      }
    },
  },
  methods: {
    handleCloseDialog() {
      this.$emit("update:visible", false);
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          let params = {
            title: this.mainForm.title,
            category_id: this.mainForm.category_id,
          };
          if (this.mainForm.product_id === 0) {
            createProductApi(params).then(() => {
              this.$message({
                type: "success",
                message: "创建成功",
              });
              this.$emit("change");
              this.handleCloseDialog();
            });
          } else {
            params.product_id = this.mainForm.product_id;
            editProductApi(params).then(() => {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.$emit("change", "refresh");
              this.handleCloseDialog();
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
